import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  VerifiedCareerRecordDraftRequest,
  VerifiedCareerRecordDraftResponse,
} from '../../entities/verified-career-records/verified-career-record';
import {
  VerifiedCareerRecordsListParams,
  VerifiedCareerRecordsListResponse,
} from '../../entities/verified-career-records/verified-career-records-list.model';

@Injectable({
  providedIn: 'root',
})
export class VerifiedCareerRecordApiService extends AccredibleApiService {
  readonly BASE_URL = '/v1/recipient/verified_career_records';

  getVerifiedCareerRecord(id: string): Observable<VerifiedCareerRecordDraftResponse> {
    return this._get(`${this.BASE_URL}/${id}`).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res, true)),
    );
  }

  createVerifiedCareerRecord(
    body: VerifiedCareerRecordDraftRequest,
  ): Observable<VerifiedCareerRecordDraftResponse> {
    return this._post(this.BASE_URL, body).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res, true)),
    );
  }

  updateVerifiedCareerRecord(
    id: string,
    body: VerifiedCareerRecordDraftRequest,
  ): Observable<VerifiedCareerRecordDraftResponse> {
    return this._put(`${this.BASE_URL}/${id}`, body).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res, true)),
    );
  }

  private _buildQueryParams(pageParams: VerifiedCareerRecordsListParams): URLSearchParams {
    const queryParams = new URLSearchParams();

    if (!pageParams) {
      return queryParams;
    }

    Object.entries(pageParams).forEach(([param, value]) => {
      if (!value) return;
      queryParams.set(param, String(value).trim());
    });

    return queryParams;
  }

  loadCareerRecords(
    pageParams: VerifiedCareerRecordsListParams,
  ): Observable<VerifiedCareerRecordsListResponse> {
    const queryParams = this._buildQueryParams(pageParams);
    const queryString = queryParams.toString();
    const url = `${this.BASE_URL}${queryString ? `?${queryString}` : ''}`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  deleteCareerRecord(careerRecordId: string): Observable<void> {
    const url = `${this.BASE_URL}/${careerRecordId}`;
    return this._delete(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
